import BlockBlot from 'quill/blots/block';

/**
 * Permit to use VIDEO
 * */
class VideoBlot extends BlockBlot {
  static create(src): HTMLElement {
    const videoHtmlElement = super.create();
    videoHtmlElement.setAttribute('src', src);
    videoHtmlElement.setAttribute('controls', 'controls');
    videoHtmlElement.setAttribute('frameborder', '0');
    videoHtmlElement.setAttribute('allowfullscreen', 'true');
    return videoHtmlElement;
  }

  static formats(domNode): string {
    return domNode.getAttribute('src');
  }
}

VideoBlot.blotName = 'video';
VideoBlot.tagName = 'video';
VideoBlot.className = 'ql-video';

export default VideoBlot;
